/* Concept R search drawer: show the "featured products" empty state while the
   input is blank, hide it once the shopper starts typing (Impulse's predictive
   search fills #predictive-search on its own). No other behaviour is touched. */
(function () {
  function wire(ps) {
    if (ps.dataset.crWired) return;
    ps.dataset.crWired = '1';
    var input = ps.querySelector('input[type="search"]');
    var empty = ps.querySelector('[data-search-empty]');
    if (!input || !empty) return;
    function sync() {
      empty.hidden = input.value.trim().length > 0;
    }
    input.addEventListener('input', sync);
    document.addEventListener('predictive-search:open', function () {
      window.setTimeout(sync, 60);
    });
    sync();
  }
  function init() {
    document
      .querySelectorAll('predictive-search[data-context="header"]')
      .forEach(wire);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
